export const THEME = {
    token: {
        fontSize: 12,
        borderRadius: 4,
        colorPrimary: '#2468F2',
        colorLink: '#2468F2',
        colorText: '#151B26',
        colorTextDescription: '#B8BABF',
        colorBorder: '#E8E9EB',
        fontFamily: 'PingFang SC',
        colorErrorBg: '#FFE8E6',
        // controlHeight: 32,
        // lineWidthFocus: 0
        // motionDurationMid: '13s', // 设置中等动画时长
        // motionDurationSlow: '15s', // 设置慢速动画时长
    },
    components: {
        Button: {
            contentFontSize: 12,
            contentFontSizeSM: 12,
            colorPrimaryHover: '#528EFF',
            paddingContentHorizontal: 12,
            colorLinkHover: '#528EFF',
            defaultBorderColor: '#E8E9EB',
            borderColorDisabled: '#F7F7F9',
            colorBgContainerDisabled: '#F7F7F9',
            colorTextDisabled: '#B8BABF',
            defaultHoverBorderColor: '#2468F2',
            defaultHoverColor: '#2468F2',
            algorithm: true, // 启用算法
        },
        Alert: {
            defaultPadding: '3px 15px',
            colorInfoBg: '#E6F0FF',
            colorInfoBorder: '#E6F0FF',
            colorErrorBg: '#FFE8E6',
            colorErrorBorder: '#FFE8E6',
            lineHeight: '24px',
            colorWarningBg: '#FFF4E6',
            colorWarningBorder: '#FFF4E6',
            colorSuccessBg: '#ECFFE6',
            colorSuccessBorder: '#ECFFE6',
            algorithm: true, // 启用算法
        },
        Input: {
            fontSizeIcon: 16,
            colorIcon: '#151B26',
            hoverBorderColor: '#2468F2',
            activeShadow: 'none',
            colorBorder: '#E8E9EB',
            algorithm: true, // 启用算法
        },
        Table: {
            headerColor: 'rgba(92, 95, 102, 1)',
            headerBg: 'rgba(247, 247, 249, 1)',
            cellPaddingBlock: 10,
            cellPaddingInline: 12,
            fontSizeSM: 12,
            fontWeightStrong: 400,
            headerFilterHoverBg: '#F7F7F9',
            rowHoverBg: '#E6F0FF',
            rowSelectedHoverBg: '#E6F0FF',
            rowSelectedBg: '#E6F0FF',
            borderColor: '#E8E9EB',
            headerBorderRadius: 4,
            colorText: '#151B26',
            headerSplitColor: '#fff',
            algorithm: true, // 启用算法
        },
        Tag: {
            fontSize: 14,
            borderRadiusSM: 2,
            algorithm: true, // 启用算法
        },
        Message: {
            contentPadding: '4px 16px',
            borderRadiusLG: 4,
            fontSize: 12,
            algorithm: true, // 启用算法
        },
        Modal: {
            centered: true,
            // bodyPadding: 30,
            borderRadiusLG: 6,
            titleColor: '#151B26',
            titleFontSize: 16,
            algorithm: true, // 启用算法
        },
        Tooltip: {
            colorBgSpotlight: '#fff',
            colorTextLightSolid: '#151B26',
            boxShadowSecondary: '0px 2px 8px 0px rgba(7, 12, 20, 0.12)',
            algorithm: true, // 启用算法
        },
        Notification: {
            algorithm: true, // 启用算法
        },
        Checkbox: {
            colorPrimaryHover: '#528EFF',
            colorBgContainerDisabled: '#F7F7F9',
            colorTextDisabled: '#B8BABF',
            algorithm: true, // 启用算法
        },
        Switch: {
            fontSizeSM: 12,
            algorithm: true, // 启用算法
        },
        Tabs: {
            titleFontSize: 14,
            titleFontSizeSM: 12,
            lineHeight: '16px',
            colorBorderSecondary: '#E8E9EB',
            algorithm: true, // 启用算法
        },
        Breadcrumb: {
            itemColor: '#84868C',
            lastItemColor: '#070C14',
            separatorColor: '#84868C',
            fontSize: 14,
            algorithm: true, // 启用算法
        },
        Drawer: {
            colorText: '#151B26',
            fontSizeLG: 16,
            algorithm: true, // 启用算法
        },
        Select: {
            optionSelectedBg: '#FFF',
            optionSelectedColor: '#2468F2',
            optionSelectedFontWeight: 500,
            hoverBorderColor: '#2468F2',
            colorBorder: '#E8E9EB',
            colorText: '#151B26',
            algorithm: true, // 启用算法
        },
        Steps: {
            iconSize: 22,
            titleLineHeight: 22,
            colorSplit: '#E8E9EB',
            algorithm: true, // 启用算法
        },
        Form: {
            labelColor: '#5C5F66',
            algorithm: true, // 启用算法
        },
        Badge: {
            dotSize: 8,
            textFontSize: 12,
            algorithm: true, // 启用算法
        },
        Spin: {
            /* 这里是你的组件 token */
            dotSize: 48,
        },
        Slider: {
            trackBg: '#2468F2',
            handleColor: '#2468F2',
            handleLineWidth: 1,
            trackHoverBg: '#2468F2',
            railBg: '#e8e9eb',
            handleLineWidthHover: 2,
            handleSize: 16,
            handleSizeHover: 20,
        },
        Radio: {
            radioSize: 16,
            dotSize: 8,
            // buttonCheckedBg: '#EEF3FE',
            // buttonSolidCheckedActiveBg: '', // 单选框实色按钮选中时的激活态背景色
            // buttonSolidCheckedBg: '#EEF3FE', // 单选框实色按钮选中时的背景色
            // buttonSolidCheckedColor: '', // 单选框实色按钮选中时的文字颜色
            // buttonSolidCheckedHoverBg: '#EEF3FE', // 单选框实色按钮选中时的悬浮态背景色
        },
        Layout: {
            bodyBg: '#f7f7f9',
            siderBg: '#FFF',
        },
        Menu: {
            fontSize: 14,
            itemColor: '#151B26',
            // collapsedWidth: 10,
            itemMarginInline: 0,
            // itemPaddingInline: 13,
            itemSelectedColor: '#2468F2',
            itemSelectedBg: '#EEF3FE',
            itemHoverBg: 'inherit',
            itemHoverColor: '#2468F2',
            itemBorderRadius: 0,
            // itemPaddingInline: 16,
            // itemMarginBlock: '0 0 4px',
        },
        Typography: {
            colorTextDescription: '#5c5f66',
            marginBottom: 0,
            titleMarginBottom: 0,
        },
        InputNumber: {
            handleHoverColor: '#2468F2',
            hoverBorderColor: '#2468F2',
        },
    },
};
